import React from 'react';

import Button from '@atlaskit/button/new';

import RovoChatIcon from '@atlaskit/icon/core/rovo-chat';

import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';

import { RecommendationButtonType } from './recommendation-button-type';

export interface RecommendationButtonProps {
	buttonType: RecommendationButtonType | null;
	label?: string;
	onClick?: React.ComponentProps<typeof Button>['onClick'];
}

/**
 * A single recommendation card action button. Renders differently based on buttonType from the backend.
 */
export const RecommendationButton: React.FC<RecommendationButtonProps> = ({
	buttonType,
	label,
	onClick,
}) => {
	switch (buttonType) {
		case RecommendationButtonType.ROVO:
			return (
				<Button appearance="default" iconBefore={RovoChatIcon} onClick={onClick}>
					{label}
				</Button>
			);
		case RecommendationButtonType.REDIRECT:
			return (
				<Button appearance="default" iconAfter={ArrowRightIcon} onClick={onClick}>
					{label}
				</Button>
			);
		// Unrecognized button type: gracefully render a plain button with no icon.
		default:
			return (
				<Button appearance="default" onClick={onClick}>
					{label}
				</Button>
			);
	}
};
